/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import { call, put, takeEvery, takeLatest, take, cancel, delay } from 'redux-saga/effects';
import { GET_SCOPES, POLL_SCOPES_START, POLL_SCOPES_STOP } from './actionTypes';
import { fetchScopesSuccess, fetchScopesFailure } from './actions';
import { Scopes } from './scopes'

//Worker saga - For scopes

function* fetchScopes(params) {
    try {
        const response = yield call(Scopes.getScopes,params)
        yield put(fetchScopesSuccess(response.data))
    } catch (error) {
        yield put(fetchScopesFailure(error))
    }
}

function* pollScopes(action) {
    while (true) {
        yield delay(30000)
        yield call(fetchScopes,{agentId: action.agentId})
    }
}

/*
  Starts fetchScopes on each dispatched `GET_SCOPES` action.
  Allows concurrent fetches of user.
*/
export function* getScopesSaga() {
    yield takeEvery(GET_SCOPES, fetchScopes)
}


export function* scopesPollingSaga() {
    while (true) {
        const watcherInstance = yield takeLatest(POLL_SCOPES_START, pollScopes)
        // cancel polling on POLL_SCOPES_STOP
        yield take(POLL_SCOPES_STOP)
        yield cancel(watcherInstance)
    }
}
